import { Injectable } from '@angular/core';
import type {
  Feature,
  FeatureCollection,
  GeoJsonProperties,
  Geometry,
  Polygon,
} from 'geojson';
import { GeoJSON, geoJSON } from 'leaflet';
import { MapApiService } from '../../api/map-api.service';
import { AbstractLayerService } from '../abstract-layer.service';
// must be imported after other imports
import '@geoman-io/leaflet-geoman-free';
import { MAP_RENDERER } from '../../../map-config';
import {
  PermitAreaProperties,
  PermitAreaResponse,
} from '../../../span-progress-entities';
@Injectable({
  providedIn: 'root',
})
export class PermitAreaService extends AbstractLayerService<GeoJSON<GeoJSON.GeoJsonProperties> | null> {
  constructor(private readonly apiService: MapApiService) {
    super(null);
  }

  loadData = this.loadPermitData;

  loadPermitData(ifs: string) {
    this.setLoading();
    this.apiService.getPermitAreaGeoJson(ifs).subscribe({
      next: (res) => {
        if (res.length) {
          const features = res.map((premitArea) =>
            this.createFeature(premitArea),
          );
          const featureCollection = this.createFeatureCollection(features);
          this.initPermitAreaLayerData(featureCollection);
        } else {
          this.layerData = geoJSON();
        }
        this.setLoaded();
      },
    });
  }

  initPermitAreaLayerData(
    featureCollection: FeatureCollection<Polygon, GeoJsonProperties>,
  ) {
    const layer = geoJSON(featureCollection, {
      style: () => {
        return {
          color: 'transparent',
          weight: 1,
          fillColor: '#6080ffd6',
          renderer: MAP_RENDERER,
        };
      },
    }).on('click', (e) => this.onClick(e));
    this.addToLayerData(layer);
  }

  private createFeature(permitArea: PermitAreaResponse) {
    return {
      type: 'Feature',
      geometry: permitArea.geometry,
      properties: {
        name: permitArea.name,
        description: permitArea.description,
        type: permitArea.type,
        status: permitArea.status,
      },
    } as Feature<Polygon, PermitAreaProperties>;
  }

  private createFeatureCollection(permitAreas: Feature<Polygon>[]) {
    return {
      type: 'FeatureCollection',
      features: permitAreas,
    } as FeatureCollection<Polygon>;
  }

  private addToLayerData(layer: GeoJSON<Polygon, Geometry>) {
    if (this.layerData === null) {
      this.layerData = layer;
    } else {
      this.layerData.addLayer(layer);
    }
  }
}
